(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/utils/huxflux-radio.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/utils/huxflux-radio.js');

'use strict';

function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const huxfluxRadio = Radio.channel(svs.numbergames.game.huxfluxRadio);
const currentlyHuxfluxing = new Map();
huxfluxRadio.reply('notifyOnAllHuxfluxEnd', notifyOnHuxfluxEnd => {
  if (!currentlyHuxfluxing.size) {
    notifyOnHuxfluxEnd === null || notifyOnHuxfluxEnd === void 0 || notifyOnHuxfluxEnd();
    return;
  }
  const onHuxfluxEnd = () => {
    if (!currentlyHuxfluxing.size) {
      notifyOnHuxfluxEnd === null || notifyOnHuxfluxEnd === void 0 || notifyOnHuxfluxEnd();
      huxfluxRadio.off('huxflux:end', onHuxfluxEnd);
    }
  };
  huxfluxRadio.on('huxflux:end', onHuxfluxEnd);
});
huxfluxRadio.on('huxflux:start', (board, numbersSize, numbersExtraSize) => {
  if (currentlyHuxfluxing.has(board)) {
    if (board.get('isActive')) {
      huxfluxRadio.trigger('huxflux:numbers', board, currentlyHuxfluxing.get(board));
    }
    return;
  }
  const numbers = board.get('numbers');
  const numbersExtra = board.get('numbersExtra');
  const numbersToHuxflux = [];
  currentlyHuxfluxing.set(board, numbersToHuxflux);
  const randomNumbers = numbers.prepareHuxflux(numbersSize);
  numbersToHuxflux.push(...randomNumbers.map(number => ({
    number
  })));
  if (numbersExtra) {
    const randomNumbers = numbersExtra.prepareHuxflux(numbersExtraSize);
    numbersToHuxflux.push(...randomNumbers.map(number => ({
      number,
      isExtra: true
    })));
  }
  setTimeout(() => {
    if (board.get('isActive')) {
      huxfluxRadio.trigger('huxflux:numbers', board, numbersToHuxflux);
    }
    huxfluxNumber(board, numbersToHuxflux);
  }, 300);
});
huxfluxRadio.on('huxflux:end', board => {
  board.numberlistsChanged();
});
function huxfluxNumber(board, _ref) {
  let _ref2 = _toArray(_ref),
    number = _ref2[0],
    numbers = _arrayLikeToArray(_ref2).slice(1);
  if (number) {
    board.addHuxfluxed(number);
    if (numbers.length) {
      setTimeout(() => {
        huxfluxNumber(board, numbers);
      }, 200);
    } else {
      setTimeout(() => {
        currentlyHuxfluxing.delete(board);
        huxfluxRadio.trigger('huxflux:end', board);
      }, 800);
    }
  }
}

 })(window);